import { ActionsCell } from "@/molecules/ActionsCell"

import type { SastGuidanceAPI } from "@/api/useSettings.types"
import type { TFunction } from "@/hooks/useTranslation"

export const GuidanceActionCell = (props: {
  actions: React.MutableRefObject<{
    onEdit: (record: Pick<SastGuidanceAPI, "id" | "name">) => void
    onDelete: (record: Pick<SastGuidanceAPI, "id" | "name">) => void
  }>
  t: TFunction
}) => {
  const { actions, t } = props

  const items = [
    { key: "edit", label: t("general.edit") },
    { key: "delete", label: t("general.delete") }
  ]

  return function GuidanceActionCellComponent(
    _: unknown,
    record: Pick<SastGuidanceAPI, "id" | "name">
  ) {
    return (
      <ActionsCell
        items={items}
        onClick={({ key }) => {
          const { onEdit, onDelete } = actions.current

          if (key === items[0].key) return onEdit(record)
          if (key === items[1].key) return onDelete(record)
        }}
      />
    )
  }
}
